<template>
  <div>
    <b-modal ref="termsDisclosureModal" hide-footer body-class="p-0">
      <terms-disclosure
        name="cancelation policy"
        @agreed="agreed"
        @dontAgree="dontAgree"
      ></terms-disclosure>
    </b-modal>
    <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
      <b-form role="form" @submit.prevent="handleSubmit(submitSettings)">
        <b-card class="border shadow-sm d-flex h-100 p-3">
          <h3>Enforce Cancelation Policy?</h3>
          <p class="text-muted">
            Set your cancelation policy, and rules.
          </p>
          <b-form-checkbox
            @change="setDefaultCancelationPolicy"
            v-model="apptSettings.hasCancelationPolicy"
            switch
            size="lg"
          ></b-form-checkbox>
          <div v-if="apptSettings.hasCancelationPolicy">
            <b-row style="max-width:300px" class="pt-3">
              <b-col>
                <small>
                  How much time prior must an appointment be canceled to not get
                  charged a cancelation fee?
                </small>
                <b-form-select
                  v-model="apptSettings.hoursToCancelAppt"
                  :options="days"
                ></b-form-select
                ><br />
              </b-col>
            </b-row>

            <user-template
              :template="apptSettings.cancelationPolicy"
              :keyItems="apptSettings.keyItems"
              title="Cancelation Policy"
              desc="Set your cancelation policy template, which will be approved by the patient upon confirmation."
              @templateUpdate="updateTemplate"
            ></user-template>
          </div>
        </b-card>

        <b-button type="submit" variant="primary"
          >Update Appointment Settings</b-button
        >
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import TermsDisclosure from "@/views/Components/Company/TermsDisclosure";
import UserTemplate from "@/views/Components/UserTemplate";

export default {
  components: {
    "user-template": UserTemplate,
    "terms-disclosure": TermsDisclosure,
  },
  props: { company: null, bindApptSettings: null },
  data() {
    return {
      apptSettings: null,
      days: [],
      hours: [],
    };
  },
  async created() {
    let a = await this.bindApptSettings();
    a.cancelApptAmountConverted = a.cancelApptAmount / 100;

    this.apptSettings = a;

    this.days.push({ value: null, text: "Any time" });

    for (let i = 1; i <= 24; i++) {
      this.days.push({
        value: i,
        text: this.$options.filters.humanize(i * 60 * 60 * 1000, "hours"),
      });
    }

    for (let i = 2; i <= 7; i++) {
      this.days.push({
        value: i,
        text: this.$options.filters.humanize(i * 24 * 60 * 60 * 1000, "hours"),
      });
    }

    this.apptSettings.hoursToCancelAppt = this.apptSettings.hoursToCancelAppt;
  },
  methods: {
    setDefaultCancelationPolicy() {
      if (this.apptSettings.hasCancelationPolicy) {
        this.apptSettings.hasCancelationPolicy = false;
        this.$refs.termsDisclosureModal.show();
      }
    },
    agreed() {
      this.$refs.termsDisclosureModal.hide();
      this.apptSettings.cancelationPolicy = this.apptSettings.defaultCancelationPolicy;
      this.apptSettings.hasCancelationPolicy = true;
    },
    dontAgree() {
      this.$refs.termsDisclosureModal.hide();
      this.apptSettings.cancelationPolicy = "";
      this.apptSettings.hasCancelationPolicy = true;
    },

    updateTemplate(m) {
      this.apptSettings.cancelationPolicy = m;
    },
    async submitSettings() {
      if (
        !this.apptSettings.cancelationPolicy &&
        this.apptSettings.hasCancelationPolicy
      ) {
        this.$emitter.emit(
          "error",
          "If you have a cancellation policy, you must set it."
        );

        return;
      }

      if (!this.apptSettings.hasCancelationPolicy) {
        this.apptSettings.cancelationPolicy = null;
        this.apptSettings.hoursToCancelAppt = null;
        this.apptSettings.cancelApptAmountConverted = null;
      }

      this.$emit("updateApptSettings", this.apptSettings);
    },
  },
};
</script>

<style></style>
